// ABOUTME: Loads screening-questionnaire fields available to applicant advanced search.
// ABOUTME: Scopes cached requests to the active company, job, and requester context.

import { useApiCache } from "customHooks/useApi";
import useList from "customHooks/useList";
import React from "react";
import {
    canRequestQuestionnaireFields,
    getQuestionnaireSearchRequest,
    getRequestableQuestionnaireFields
} from "./screeningQuestionnaireFilterScope";

const useAdvancedSearchQuestionnaires = (
    moduleName: string,
    companyId: number
) => {
    const [listData] = useList();
    const jobId = listData?.tempInfo?.otherParamsQuery?.jobId;
    const request = getQuestionnaireSearchRequest({
        companyId,
        jobId,
        listApiAddress: listData.tempInfo.listApiAddress
    });
    const [customFields, runQuery] = useApiCache(
        request.endpoint,
        "post",
        request.params,
        true,
        1000 * 60 * 10
    );
    const modulesAllowed: string[] = [
        "APPLICANTLIST",
        "JOBAPPLICANTLISTFILTERKANBAN",
        "JOBAPPLICANTLISTJOBVIEW"
    ];
    React.useEffect(() => {
        if (
            modulesAllowed.includes(moduleName) &&
            canRequestQuestionnaireFields(moduleName, jobId)
        ) {
            runQuery(request.params, request.endpoint);
        }
    }, [moduleName, companyId, jobId, request.isJobRequest]);

    const fieldsDef: Compleo.IObject[] = modulesAllowed.includes(moduleName)
        ? getRequestableQuestionnaireFields(
              customFields.response?.data?.data || [],
              moduleName,
              jobId,
              customFields.useQueryKey?.[3]?.jobId
          )
        : [];

    return {
        fieldsDef: fieldsDef,
        readyCustomFields:
            customFields.status === "success" ||
            !modulesAllowed.includes(moduleName)
    };
};

export default useAdvancedSearchQuestionnaires;
